import { Contract, NFTResult, PriceList, Stake, Token } from '@jdiyield/interfaces'
import { api } from '@jdiyield/utils'
import axios from 'axios'
import BigNumber from 'bignumber.js'
import { print } from 'graphql'
import gql from 'graphql-tag'

import { findToken } from '../utils'

export async function getAxieInfinity(account: string): Promise<NFTResult[]> {
  try {
    const { data } = await api.post(`https://axieinfinity.com/graphql-server-v2/graphql`, {
      operationName: null,
      variables: {
        auctionType: 'All',
        criteria: {
          bodyShapes: null,
          breedCount: null,
          breedable: null,
          classes: null,
          hp: [],
          morale: [],
          numMystic: null,
          parts: null,
          pureness: null,
          region: null,
          skill: [],
          speed: [],
          stages: null,
          title: null
        },
        from: 0,
        owner: account,
        size: 1000,
        sort: 'IdDesc'
      },
      query: print(gql`
        query GetAxieBriefList(
          $auctionType: AuctionType
          $criteria: AxieSearchCriteria
          $from: Int
          $sort: SortBy
          $size: Int
          $owner: String
        ) {
          axies(auctionType: $auctionType, criteria: $criteria, from: $from, sort: $sort, size: $size, owner: $owner) {
            total
            results {
              ...AxieBrief
              __typename
            }
            __typename
          }
        }
        fragment AxieBrief on Axie {
          id
          name
          stage
          class
          breedCount
          image
          title
          battleInfo {
            banned
            __typename
          }
          auction {
            currentPrice
            currentPriceUSD
            __typename
          }
          parts {
            id
            name
            class
            type
            specialGenes
            __typename
          }
          __typename
        }
      `)
    })
    const result = data?.data?.axies?.results?.map(
      ({ id, image, name }) =>
        ({
          name: name ?? '',
          tokenID: id,
          asset_url: image,
          thumbnail_url: image,
          link: `https://marketplace.axieinfinity.com/axie/${id}`
        } as NFTResult)
    )
    return result
  } catch (error) {
    console.log(error)
    return []
  }
}
//https://game-api.skymavis.com/game-api/clients/0xfa935fdf58504342a72d24d87bb60205ed051e63/items/1
// api for fetch lock SLP
export const getAxieLockReward = async (
  walletAddress: string,
  ct: Contract,
  tokens: Token[],
  priceList: PriceList
): Promise<Stake[]> => {
  try {
    const { rewardAddress, contractAddress } = ct
    const { data } = await axios.get(
      `https://game-api.skymavis.com/game-api/clients/${walletAddress}/items/${contractAddress}`
    )
    const rewardBalance = data.total
    const rewardToken = findToken(tokens, rewardAddress)
    const usdPerCoin = priceList[rewardToken?.address]?.usd || 0
    const result = [
      {
        ...ct,
        logo: rewardToken?.logo,
        reward: rewardBalance,
        rewardSymbol: rewardToken?.symbol || '???',
        rewardUSD: usdPerCoin * rewardBalance,
        worth: 0,
        token: {
          logo: rewardToken?.logo,
          symbol: rewardToken?.symbol || '???',
          name: rewardToken?.symbol || '???',
          address: rewardToken?.address,
          amount: new BigNumber(0),
          decimals: rewardToken?.decimals,
          value: 0
        },
        pool: 0,
        balance: '0',
        lpAddress: rewardToken?.address
      }
    ]
    return result
  } catch (error) {
    console.log('getAxieLockReward', error)
    return []
  }
}
